import type { CSSProperties } from "react";

/**
 * Flat UI wordmark — no raster chrome. Uses display font + brand tokens.
 * Use in nav/sidebars; keep PNG / full badge for marketing and splash screens.
 */
export type Fit2LiftWordmarkProps = {
  className?: string;
  /** sm = compact header; md = app sidebar; lg = hero */
  size?: "sm" | "md" | "lg";
  /** onDark: white + steel + highlight “2”; onLight: charcoal + highlight “2” */
  variant?: "onDark" | "onLight";
};

const sizeClass: Record<NonNullable<Fit2LiftWordmarkProps["size"]>, string> = {
  sm: "text-2xl leading-none sm:text-3xl",
  md: "text-3xl leading-none sm:text-[2rem]",
  lg: "text-4xl leading-none sm:text-5xl",
};

/** Tight edge fill so Barlow reads closer to plate / stencil type on screen. */
const ink: CSSProperties = {
  WebkitTextStroke: "0.7px currentColor",
  paintOrder: "stroke fill",
};

export function Fit2LiftWordmark({ className = "", size = "md", variant = "onDark" }: Fit2LiftWordmarkProps) {
  const fitLift =
    variant === "onDark"
      ? "text-[var(--color-white)]"
      : "text-[var(--color-charcoal)]";
  const two = "text-[var(--color-highlight-blue)]";

  return (
    <span
      className={
        "inline-flex select-none items-baseline gap-0 font-[var(--font-display)] font-black italic uppercase tracking-[0.06em] antialiased " +
        sizeClass[size] +
        " " +
        className
      }
      aria-label="Fit2Lift"
    >
      <span className={fitLift} style={ink}>
        FIT
      </span>
      <span className={two} style={ink}>
        2
      </span>
      <span className={fitLift} style={ink}>
        LIFT
      </span>
    </span>
  );
}
